import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { Color } from '../../types/colors';
import styles from './Icon.module.scss';
import { IconArchive } from './IconArchive';
import { IconArrowDown } from './IconArrowDown';
import { IconArrowDownLeft } from './IconArrowDownLeft';
import { IconArrowLeft } from './IconArrowLeft';
import { IconArrowRight } from './IconArrowRight';
import { IconArrowsLeftRight } from './IconArrowsLeftRight';
import { IconArrowUp } from './IconArrowUp';
import { IconArrowUpDownCircle } from './IconArrowUpDownCircle';
import { IconBalcony } from './IconBalcony';
import { IconBank } from './IconBank';
import { IconBuilding } from './IconBuilding';
import { IconCalendar } from './IconCalendar';
import { IconCamera } from './IconCamera';
import { IconCertificate } from './IconCertificate';
import { IconChart } from './IconChart';
import { IconCheck } from './IconCheck';
import { IconCheckCircle } from './IconCheckCircle';
import { IconCheckCloud } from './IconCheckCloud';
import { IconCheckSquare } from './IconCheckSquare';
import { IconChevronBigDown } from './IconChevronBigDown';
import { IconChevronBigLeft } from './IconChevronBigLeft';
import { IconChevronBigRight } from './IconChevronBigRight';
import { IconChevronBigUp } from './IconChevronBigUp';
import { IconChevronDoubleRight } from './IconChevronDoubleRight';
import { IconChevronDown } from './IconChevronDown';
import { IconChevronLeft } from './IconChevronLeft';
import { IconChevronRight } from './IconChevronRight';
import { IconChevronUp } from './IconChevronUp';
import { IconClock } from './IconClock';
import { IconClose } from './IconClose';
import { IconCloseCircle } from './IconCloseCircle';
import { IconCog } from './IconCog';
import { IconCopyright } from './IconCopyright';
import { IconCross } from './IconCross';
import { IconDelivery } from './IconDelivery';
import { IconDeviceComputer } from './IconDeviceComputer';
import { IconDeviceMobile } from './IconDeviceMobile';
import { IconDeviceUnclear } from './IconDeviceUnclear';
import { IconDocument } from './IconDocument';
import { IconDocumentBan } from './IconDocumentBan';
import { IconDocumentCheck } from './IconDocumentCheck';
import { IconDocumentEnergy } from './IconDocumentEnergy';
import { IconDocumentHouse } from './IconDocumentHouse';
import { IconDotsHorizontal } from './IconDotsHorizontal';
import { IconDotsVertical } from './IconDotsVertical';
import { IconDownload } from './IconDownload';
import { IconDrugstore } from './IconDrugstore';
import { IconEdit } from './IconEdit';
import { IconElectricSocket } from './IconElectricSocket';
import { IconElevator } from './IconElevator';
import { IconEnvelope } from './IconEnvelope';
import { IconEnvelopeCheck } from './IconEnvelopeCheck';
import { IconEquipment } from './IconEquipment';
import { IconEye } from './IconEye';
import { IconFacebook } from './IconFacebook';
import { IconFloorArea } from './IconFloorArea';
import { IconFloorPlan } from './IconFloorPlan';
import { IconGlobe } from './IconGlobe';
import { IconGym } from './IconGym';
import { IconHandArrow } from './IconHandArrow';
import { IconHandButton } from './IconHandButton';
import { IconHandCheck } from './IconHandCheck';
import { IconHandClick } from './IconHandClick';
import { IconHandDoubleClick } from './IconHandDoubleClick';
import { IconHandRight } from './IconHandRight';
import { IconHandUp } from './IconHandUp';
import { IconHeart } from './IconHeart';
import { IconHome } from './IconHome';
import { IconHospital } from './IconHospital';
import { IconHouseGarage } from './IconHouseGarage';
import { IconInfoCircle } from './IconInfoCircle';
import { IconInstagram } from './IconInstagram';
import { IconInternet } from './IconInternet';
import { IconKey } from './IconKey';
import { IconLightbulb } from './IconLightbulb';
import { IconLocation } from './IconLocation';
import { IconLock } from './IconLock';
import { IconLogoSymbol } from './IconLogoSymbol';
import { IconLogout } from './IconLogout';
import { IconMarket } from './IconMarket';
import { IconMenu } from './IconMenu';
import { IconMessage } from './IconMessage';
import { IconMessageSend } from './IconMessageSend';
import { IconMessageText } from './IconMessageText';
import { IconMessageUnread } from './IconMessageUnread';
import { IconMinus } from './IconMinus';
import { IconMobileCheck } from './IconMobileCheck';
import { IconNursery } from './IconNursery';
import { IconOffice } from './IconOffice';
import { IconParking } from './IconParking';
import { IconPercentage } from './IconPercentage';
import { IconPhone } from './IconPhone';
import { IconPicture } from './IconPicture';
import { IconPictureAdd } from './IconPictureAdd';
import { IconPlayCircle } from './IconPlayCircle';
import { IconPlus } from './IconPlus';
import { IconProfile } from './IconProfile';
import { IconPublicTransport } from './IconPublicTransport';
import { IconQuestionMarkCircle } from './IconQuestionMarkCircle';
import { IconReload } from './IconReload';
import { IconRestaurant } from './IconRestaurant';
import { IconSchool } from './IconSchool';
import { IconSearch } from './IconSearch';
import { IconSettings } from './IconSettings';
import { IconShare } from './IconShare';
import { IconShareArrow } from './IconShareArrow';
import { IconSport } from './IconSport';
import { IconStack } from './IconStack';
import { IconStar } from './IconStar';
import { IconStarSolid } from './IconStarSolid';
import { IconStarSquare } from './IconStarSquare';
import { IconStore } from './IconStore';
import { IconTag } from './IconTag';
import { IconTrash } from './IconTrash';
import { IconTreeHouse } from './IconTreeHouse';
import { IconTriangleDown } from './IconTriangleDown';
import { IconTriangleUp } from './IconTriangleUp';
import { IconTwitter } from './IconTwitter';
import { IconGarage } from './IconGarage';
import { IconEnergy } from './IconEnergy';
import { IconUserCheck } from './IconUserCheck';
import { IconWallCalendar } from './IconWallCalendar';
import { IconWalletAdd } from './IconWalletAdd';
import { IconWarning } from './IconWarning';
import { IconWatchdog } from './IconWatchdog';
import {IconHeartFilled} from "./IconHeartFilled";
import {IconCopy} from "./IconCopy";

export type IconProps = {
	id?: string;
	name?: keyof typeof icons;
	width?: number;
	height?: number;
	position?: 'start' | 'end' | 'middle';
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
	color?: Color;
	className?: string;
};

type IconWithIdProps = {
	id: string;
	children: ReactNode;
};
type IconWithNameProps = {
	name: keyof typeof icons;
};

const Icon: FC<IconProps & (IconWithIdProps | IconWithNameProps)> = (props) => {
	const { id, name, width = 24, height = 24, position, size, color, className, children } = props;

	const NamedIcon = name ? icons[name] : null;

	return id ? (
		<span
			className={classNames(styles.icon, 'icon', className, {
				[styles[`icon--${size}`]]: size,
				[styles[`icon--${position}`]]: position,
				[`text-${color}`]: color,
			})}
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
				{children}
			</svg>
		</span>
	) : (
		NamedIcon && <NamedIcon {...props} />
	);
};

export const icons = {
	Archive: IconArchive,
	ArrowDown: IconArrowDown,
	ArrowDownLeft: IconArrowDownLeft,
	ArrowLeft: IconArrowLeft,
	ArrowRight: IconArrowRight,
	ArrowsLeftRight: IconArrowsLeftRight,
	ArrowUp: IconArrowUp,
	ArrowUpDownCircle: IconArrowUpDownCircle,
	Balcony: IconBalcony,
	Bank: IconBank,
	Building: IconBuilding,
	Calendar: IconCalendar,
	Camera: IconCamera,
	Certificate: IconCertificate,
	Clock: IconClock,
	Close: IconClose,
    Copy: IconCopy,
	CloseCircle: IconCloseCircle,
	Cog: IconCog,
	Copyright: IconCopyright,
	Cross: IconCross,
	Delivery: IconDelivery,
	DeviceComputer: IconDeviceComputer,
	DeviceMobile: IconDeviceMobile,
	DeviceUnclear: IconDeviceUnclear,
	Document: IconDocument,
	DocumentBan: IconDocumentBan,
	DocumentEnergy: IconDocumentEnergy,
	DocumentHouse: IconDocumentHouse,
	DocumentCheck: IconDocumentCheck,
	DotsHorizontal: IconDotsHorizontal,
	DotsVertical: IconDotsVertical,
	Download: IconDownload,
	Drugstore: IconDrugstore,
	Edit: IconEdit,
	ElectricSocket: IconElectricSocket,
	Elevator: IconElevator,
    Energy: IconEnergy,
	Envelope: IconEnvelope,
	EnvelopeCheck: IconEnvelopeCheck,
	Equipment: IconEquipment,
	Eye: IconEye,
	Facebook: IconFacebook,
	FloorArea: IconFloorArea,
	FloorPlan: IconFloorPlan,
    Garage: IconGarage,
	Globe: IconGlobe,
	Gym: IconGym,
	HandArrow: IconHandArrow,
	HandButton: IconHandButton,
	HandClick: IconHandClick,
	HandDoubleClick: IconHandDoubleClick,
	HandCheck: IconHandCheck,
	HandRight: IconHandRight,
	HandUp: IconHandUp,
	Heart: IconHeart,
    HeartFilled: IconHeartFilled,
	Home: IconHome,
	Hospital: IconHospital,
	HouseGarage: IconHouseGarage,
	Chart: IconChart,
	Check: IconCheck,
	CheckCircle: IconCheckCircle,
	CheckCloud: IconCheckCloud,
	CheckSquare: IconCheckSquare,
	ChevronBigDown: IconChevronBigDown,
	ChevronBigLeft: IconChevronBigLeft,
	ChevronBigRight: IconChevronBigRight,
	ChevronBigUp: IconChevronBigUp,
	ChevronDoubleRight: IconChevronDoubleRight,
	ChevronDown: IconChevronDown,
	ChevronLeft: IconChevronLeft,
	ChevronRight: IconChevronRight,
	ChevronUp: IconChevronUp,
	InfoCircle: IconInfoCircle,
	Instagram: IconInstagram,
	Internet: IconInternet,
	Key: IconKey,
	Lightbulb: IconLightbulb,
	Location: IconLocation,
	Lock: IconLock,
	LogoSymbol: IconLogoSymbol,
	Logout: IconLogout,
	Market: IconMarket,
	Menu: IconMenu,
	Message: IconMessage,
	MessageSend: IconMessageSend,
	MessageText: IconMessageText,
	MessageUnread: IconMessageUnread,
	Minus: IconMinus,
	MobileCheck: IconMobileCheck,
	Nursery: IconNursery,
	Office: IconOffice,
	Parking: IconParking,
	Percentage: IconPercentage,
	Phone: IconPhone,
	Picture: IconPicture,
	PictureAdd: IconPictureAdd,
	PlayCircle: IconPlayCircle,
	Plus: IconPlus,
	Profile: IconProfile,
	PublicTransport: IconPublicTransport,
	QuestionMarkCircle: IconQuestionMarkCircle,
	Reload: IconReload,
	Restaurant: IconRestaurant,
	Search: IconSearch,
	Settings: IconSettings,
	Share: IconShare,
	ShareArrow: IconShareArrow,
	School: IconSchool,
	Sport: IconSport,
	Stack: IconStack,
	Star: IconStar,
	StarSolid: IconStarSolid,
	StarSquare: IconStarSquare,
	Store: IconStore,
	Tag: IconTag,
	Trash: IconTrash,
	TreeHouse: IconTreeHouse,
	TriangleDown: IconTriangleDown,
	TriangleUp: IconTriangleUp,
	Twitter: IconTwitter,
	UserCheck: IconUserCheck,
	WallCalendar: IconWallCalendar,
	WalletAdd: IconWalletAdd,
	Warning: IconWarning,
	Watchdog: IconWatchdog,
};

export default Object.assign(Icon, icons);
